import React, { FC } from 'react'

import { IconUsersProps } from './IconUsers.types'
import * as Styled from './styles/IconUsers.style'

import { nonThemeableRules } from '../../ruleSet'

const IconUsers: FC<IconUsersProps> = ({
  size = nonThemeableRules.defaultSize as number as IconUsersProps['size'],
  isResponsive = false,
}: IconUsersProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M41 31.317C40.11 26.155 36.938 23 33 23c-2.86 0-5.317 1.663-6.787 4.55l-.028.058'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M33 13h5v5a5 5 0 1 1-5-5Z' stroke='#EA1A1A' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='M7 35c1.22-7.435 5.585-11.975 11-11.975s9.777 4.547 11 11.985'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M18 9.025h7v7a7 7 0 1 1-7-7Z' stroke='#fff' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconUsers
